import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import ChatWidget from '@/components/ChatWidget';

export default function Layout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background" data-testid="app-layout">
      <Header
        sidebarCollapsed={collapsed}
        onToggleSidebar={() => setMobileOpen(prev => !prev)}
      />
      <Sidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed(prev => !prev)}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      <main
        className={`transition-all duration-300 pt-6 pb-12 px-4 lg:px-8 ${collapsed ? 'lg:ml-[68px]' : 'lg:ml-60'}`}
        data-testid="main-content"
      >
        <Outlet />
        <Footer />
      </main>
      <ChatWidget />
    </div>
  );
}
